import React from 'react'
import { ToolkitPageLayout } from '../../../components'
import { EchoInfoImage, EchoFlyer1Image, EchoFlyer2Image } from 'assets'
import { Link } from 'react-router-dom'
// We might need Link or other imports depending on the content migrated.

export const ProvidersEchoPage: React.FC = () => {
  // Find the object with title: "Extension for Community Health Outcomes (ECHO)"
  // from plans/toolkit_content.json
  // The html_content is:
  /*
<figure class="wp-block-pullquote is-style-default"><blockquote><p>Project ECHO is a guided practice model designed to provide best-practice specialty care and reduce health disparities by connecting providers with specialists through ongoing interactive, telementoring sessions.</p></blockquote></figure>

<hr class="wp-block-separator"/>

<h3><strong>Instructions:</strong></h3>

<p style="font-size:26px">-   Join ECHO! More information linked below:</p>

<figure class="wp-block-image size-large"><a href="https://www.hopkinsmedicine.org/medicine/sickle" target="_blank" rel="noopener"><img src="https://scdtoolkit.jh.edu/wp-content/uploads/2021/02/Screen-Shot-2021-02-17-at-12.37.53-AM.png" alt="" class="wp-image-197"/></a></figure>

<p style="font-size:26px"><span style="text-decoration: underline;">All Providers</span>: <em>Johns Hopkins Sickle Cell Disease ECHO </em>is hosted every Wednesday, 1:00 p.m. EST.</p>

<p style="font-size:26px"><span style="text-decoration: underline;">Advanced Practice Providers</span>: <em>SAPPORT ECHO</em> is hosted every first Tuesday, 8:00 a.m. CST / 9:00 a.m. EST and every third Thursday, 12:00 p.m. EST.</p>

<p>Choose flyer below for more information:</p>

<div class="wp-block-columns">
<div class="wp-block-column">
<figure class="wp-block-image alignfull size-large"><a href="https://docs.google.com/document/d/e/2PACX-1vT_1wJgth_GIBXdlKXmiszH6Kg41wiBSsR3xgBsUV21c2BLyBFtsYj0qnh1f5dpoD5Iog49cgQA9iHR/pub" target="_blank" rel="noopener"><img src="https://scdtoolkit.jh.edu/wp-content/uploads/2021/02/Screen-Shot-2021-02-24-at-11.29.42-AM.png" alt="" class="wp-image-324"/></a></figure>
</div>

<div class="wp-block-column">
<figure class="wp-block-image alignfull size-large"><a href="https://docs.google.com/document/d/e/2PACX-1vSFCfP3AALYX4ppfzxv-ZOLjA-70zQgqK5gb8vKj_qXidgfHjLccFZbV7xrgjP9gS3lL8bMiqW6mm4L/pub" target="_blank" rel="noopener"><img src="https://scdtoolkit.jh.edu/wp-content/uploads/2021/02/Screen-Shot-2021-02-24-at-11.30.26-AM.png" alt="" class="wp-image-325"/></a></figure>
</div>
</div>

<p style="font-size:26px"><em>For more information or to register to attend, contact: <span style="text-decoration: underline;">sinerge@jhmi.edu</span> or 443-287-0608.</em></p>

<hr class="wp-block-separator"/>

<div class="wp-block-buttons">
<div class="wp-block-button"><a class="wp-block-button__link" href="http://scdtoolkit.jh.edu/?page_id=83"><span style="color:#450001" class="has-inline-color">All done? click here to return to the providers screen</span></a></div>
</div>
  */

  // Placeholder image paths - these would need to be updated or imported from assets
  // const echoInfoImagePath = 'assets/echo-info.png' // Example, replace with actual if available
  // const flyer1ImagePath = 'assets/flyer1.png' // Example
  // const flyer2ImagePath = 'assets/flyer2.png' // Example

  return (
    <ToolkitPageLayout
      title="Extension for Community Health Outcomes (ECHO)"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Providers', path: '/toolkit/providers' },
        { label: 'ECHO', path: '/toolkit/providers/echo' }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416]">
        <blockquote className="border-l-4 border-[#A6410A] pl-4 italic text-xl text-[#713d43]">
          <p>
            Project ECHO is a guided practice model designed to provide
            best-practice specialty care and reduce health disparities by
            connecting providers with specialists through ongoing interactive,
            telementoring sessions.
          </p>
        </blockquote>

        <hr className="my-6 border-[#A6410A]" />

        <h3 className="font-bold text-2xl text-[#142841]">Instructions:</h3>

        <p className="text-lg">- Join ECHO! More information linked below:</p>

        <figure className="my-4">
          <a
            href="https://www.hopkinsmedicine.org/medicine/sickle"
            target="_blank"
            rel="noopener noreferrer"
            className="block max-w-xl mx-auto"
          >
            <img
              src={EchoInfoImage}
              alt="Project ECHO Information"
              className="w-full object-contain rounded-md shadow-md"
            />
          </a>
        </figure>

        <p className="text-lg">
          <span className="underline">All Providers</span>:{' '}
          <em>Johns Hopkins Sickle Cell Disease ECHO </em>is hosted every
          Wednesday, 1:00 p.m. EST.
        </p>

        <p className="text-lg">
          <span className="underline">Advanced Practice Providers</span>:{' '}
          <em>SAPPORT ECHO</em> is hosted every first Tuesday, 8:00 a.m. CST /
          9:00 a.m. EST and every third Thursday, 12:00 p.m. EST.
        </p>

        <p className="text-lg">Choose a flyer below for more information:</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-4">
          <figure>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vT_1wJgth_GIBXdlKXmiszH6Kg41wiBSsR3xgBsUV21c2BLyBFtsYj0qnh1f5dpoD5Iog49cgQA9iHR/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* Replace with actual image from assets if available */}
              <img
                src={EchoFlyer1Image}
                alt="Project ECHO Flyer 1"
                className="w-full object-contain rounded-md shadow-md"
              />
            </a>
          </figure>
          <figure>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vSFCfP3AALYX4ppfzxv-ZOLjA-70zQgqK5gb8vKj_qXidgfHjLccFZbV7xrgjP9gS3lL8bMiqW6mm4L/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={EchoFlyer2Image}
                alt="Project ECHO Flyer 2"
                className="w-full object-contain rounded-md shadow-md"
              />
            </a>
          </figure>
        </div>

        <p className="text-lg">
          <em>
            For more information or to register to attend, contact:{' '}
            <span className="underline">sinerge@jhmi.edu</span> or 443-287-0608.
          </em>
        </p>

        <hr className="my-6 border-[#A6410A]" />

        <div className="flex justify-center mt-8 mb-4">
          <Link
            to="/toolkit/providers"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white font-semibold py-3 px-6 rounded-md text-center text-sm transition-colors duration-200"
          >
            All done? Click here to return to the providers screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
